import AllOutIcon from '@mui/icons-material/AllOut';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroForaOrgaoJudicante extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Fora do órgão judicante';
    }

    getIconeFiltroRapido() {
        return <AllOutIcon />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return registro.localIncompativelJulgamento !== undefined;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
